import React from 'react';
import { Col, Row } from 'react-bootstrap';
import DashCardBlue from '../components/DashCardBlue';
import DummySmallBarChart from '../components/DummySmallBarChart';
import { useTranslation } from 'react-i18next';
const TotalCumulativeBenefit = _ref => {
  let {
    dashboardData
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderCardBody = () => {
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 7,
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "text-dark-white text-truncate mb-0"
    }, window.MARKET_CONSTANTS.CURRENCY_SYMBOL, window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(Math.round(dashboardData.total_claim_benefit_amount_up_to_year)))), /*#__PURE__*/React.createElement(Col, {
      xs: 5,
      className: "d-flex justify-content-end"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '75px',
        width: '75px'
      }
    }, /*#__PURE__*/React.createElement(DummySmallBarChart, null))));
  };
  return /*#__PURE__*/React.createElement(DashCardBlue, {
    title: t('chart_title_cumulative_benefit_to_date'),
    body: renderCardBody()
  });
};
export default TotalCumulativeBenefit;